export class BatchInterface {
  cancelcmd: string;
  submitcmd: string;
  statcmd: string;
}
